<template>
  <row>
    <Col
      v-for='(item, index) of baseInfoList' :key='index' :span='item.span'
      class='flex align-items-center pd-tp-20 pd-rt-10'>
      <label class='width-70' style='min-width: 70px;'> {{ item.label }} </label>
      <p class='text-ellipsis'>
        {{ baseInfoData[item.column] }}
      </p>
    </Col>
  </row>
</template>

<script>
export default {
  name: 'baseInformation',
  props: {
    baseInfoData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      baseInfoList: [
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${$it('fL.platform_billNo')}:` // 平台单号
        },
        {
          column: 'CP_C_SHOP_TITLE',
          span: 6,
          label: `${$it('fL.orderShop')}:` // 下单店铺
        },
        {
          column: 'CP_C_REGION_PROVINCE_ENAME',
          span: 6,
          label: `${$it('fL.consignee_province')}:` // 收货人省份
        },
        {
          column: 'CP_C_REGION_CITY_ENAME',
          span: 6,
          label: '收货人城市:' // 收货人城市
        },
        {
          column: 'CP_C_REGION_AREA_ENAME',
          span: 6,
          label: `收货人区县:` // 收货人区县
        },
        {
          column: 'RECEIVER_ADDRESS',
          span: 6,
          label: `${$it('fL.aconsignee_address')}:` // 收货人地址
        },
        {
          column: 'SELLER_MEMO',
          span: 12,
          label: `${$it('fL.sellerNotes')}:` // 卖家备注
        }
      ]
    };
  }
};
</script>

<style scoped>
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
